const baseDomainResources = "https://org1.egurukulapps.com/campusresources";
const baseDomainIdentity = "https://org1.egurukulapps.com/campusidentity";
const baseDomainInfrastructure = "https://org1.egurukulapps.com/campusinfrastructure";

// const baseDomainResources = "http://localhost:8001/campusresources";
// const baseDomainIdentity = "http://localhost:8000/campusidentity";
// const baseDomainInfrastructure = "http://localhost:8002/campusinfrastructure";

const configData = {
  // ==========================================
  // 1. CAMPUS IDENTITY SERVICES (Port 8000)
  // ==========================================
  "REGISTER_USER": `${baseDomainIdentity}/api/users`,
  "LOGIN_USER": `${baseDomainIdentity}/api/users/login`,
  "GET_USER_DOCUMENTS": `${baseDomainIdentity}/api/users/documents`,
  "UPLOAD_DOCUMENT": `${baseDomainIdentity}/api/users/document`,
  "DELETE_DOCUMENT": `${baseDomainIdentity}/api/users/document`,
  "GET_PASSPORT_PHOTO": `${baseDomainIdentity}/api/users/documents`,
  "UPDATE_USER": `${baseDomainIdentity}/api/users`,
  "GET_USER_DETAILS": `${baseDomainIdentity}/api/users`,
  "GET_ROLE_PERMISSIONS": `${baseDomainIdentity}/api/roles-permissions`,
  "UPDATE_ROLE_PERMISSIONS": `${baseDomainIdentity}/api/roles-permissions`,
  "GET_USERS_BY_TYPE": `${baseDomainIdentity}/api/users/org`,
  "DELETE_USER": `${baseDomainIdentity}/api/users`,
  "GET_USER_DOCUMENT_BY_TYPE": `${baseDomainIdentity}/api/users/documents`,
  "GET_USER_BY_EMAIL_WITH_PARAM": `${baseDomainIdentity}/api/users/email`,
  "GET_STUDENTS_BY_CLASS": `${baseDomainIdentity}/api/users/students`,
  "GET_STUDENT_BY_ID": `${baseDomainIdentity}/api/users`,
  "GET_ORG_BY_ID": `${baseDomainIdentity}/api/org`,
  "UPDATE_USER_DOCUMENT": `${baseDomainIdentity}/api/users/document`,
  "GET_FACULTIES_BY_ORG": `${baseDomainIdentity}/api/users/org`,
  "GET_FACULTY_BY_TYPE": `${baseDomainIdentity}/api/users/org`,
  "IDENTITY_ORG": `${baseDomainIdentity}/api/org`,

  // Dynamic Identity Routes
  get_identity_identity_users: (facultyId) => `${baseDomainIdentity}/api/users/${facultyId}`,
  get_identity_identity_users_org_users: (orgId) => `${baseDomainIdentity}/api/users/org/${orgId}/users`,
  get_identity_identity_org_orgid: (p1, p2) => `${baseDomainIdentity}/api/org/${p1}?orgId=${p2}`,
  get_identity_identity_org_parentorg: (pId) => `${baseDomainIdentity}/api/org/parentOrg/${pId}`,
  get_identity_identity_org: (orgId) => `${baseDomainIdentity}/api/org/${orgId}`,
  get_identity_identity_users_document: (userId) => `${baseDomainIdentity}/api/users/document/${userId}`,
  getFacultyCountByType: (orgId) => `${baseDomainIdentity}/api/users/org/${orgId}/faculty/count-by-type`,

  // ==========================================
  // 2. CAMPUS RESOURCE SERVICES (Port 8001)
  // ==========================================
  "USERS_GET": `${baseDomainResources}/api/users/list`,
  "GET_USER_BY_EMAIL": `${baseDomainResources}/api/users/email`,
  "ORG_BY_USER": `${baseDomainResources}/api/org`,
  "CREATE_USER": `${baseDomainResources}/api/users`,
  "CREATE_ORG": `${baseDomainResources}/api/org`,
  "CLASSES": `${baseDomainResources}/api/classes`,
  "EVENTS": `${baseDomainResources}/api/events`,
  "SCHEDULES": `${baseDomainResources}/api/schedules`,
  "SEARCH_USERS": `${baseDomainResources}/api/users/search`,
  "NOTIFICATION_EMAIL": `${baseDomainResources}/api/notification/email`,
  "CREATE_ORDER": `${baseDomainResources}/api/feepayments/create-order`,
  "ORG": `${baseDomainResources}/api/org`,
  "FEE_PAYMENTS": `${baseDomainResources}/api/feepayments`,
  "GET_COURSES": `${baseDomainResources}/api/courses/org`,
  "GET_COURSE_CONTENTS": `${baseDomainResources}/api/coursecontents/list`,
  "VERIFY_PAYMENT": `${baseDomainResources}/api/feepayments/verify-payment`,
  "GET_CLASSES_BY_ORG": `${baseDomainResources}/api/classes/org`,
  "CREATE_CLASS": `${baseDomainResources}/api/classes`,
  "DELETE_CLASS_BY_ID": `${baseDomainResources}/api/classes`,
  "GET_CLASS_SCHEDULE_BY_ID": `${baseDomainResources}/api/classes`,
  "UPDATE_CLASS_SCHEDULE_BY_ID": `${baseDomainResources}/api/classes`,
  "GET_SUBJECTS_BY_ORG": `${baseDomainResources}/api/courses/org`,
  "CREATE_SUBJECT": `${baseDomainResources}/api/courses`,
  "UPDATE_SUBJECT": `${baseDomainResources}/api/courses`,
  "DELETE_SUBJECT": `${baseDomainResources}/api/courses`,
  "GET_SUBJECT_BY_ID": `${baseDomainResources}/api/courses`,
  "GET_COURSE_PLANS_BY_FACULTY": `${baseDomainResources}/api/course-plan/faculty`,
  "GET_COURSE_BY_ID": `${baseDomainResources}/api/courses`,
  "GET_CLASS_BY_ID": `${baseDomainResources}/api/classes`,

  // AI & Dashboards
  "AI_CHAT": `${baseDomainResources}/api/ai-conversation/chat`,
  "AI_CHAT_HISTORY": `${baseDomainResources}/api/ai-conversation/user`,
  "AI_API_URL": `${baseDomainResources}/api/ai-conversation/chat`,
  "AI_CHAT_HISTORY_URL": `${baseDomainResources}/api/ai-conversation/user`,
  "COUNT_BY_USER_TYPE": `${baseDomainResources}/api/dashboard/count-by-userType`,
  "COURSE_COUNT": `${baseDomainResources}/api/dashboard/courses/count`,
  "ATTENDANCE_SUMMARY": `${baseDomainResources}/api/dashboard/attendance/summary`,

  // Courses & Performance
  "COURSE_API": `${baseDomainResources}/api/courses`,
  "COURSE_PLAN": `${baseDomainResources}/api/course-plan`,
  "GET_COURSE_PLAN": `${baseDomainResources}/api/course-plan`,
  "STUDENT_PERFORMANCE": `${baseDomainResources}/api/student-performance`,
  "COURSE_BY_ID": `${baseDomainResources}/api/courses`,
  "CLASS_BY_ID": `${baseDomainResources}/api/classes`,
  "CLASS_BY_ORG": `${baseDomainResources}/api/classes/org`,
  "COURSE_API_URL": `${baseDomainResources}/api/courses`,
  "GET_COURSE_PLAN_BY_CLASS": `${baseDomainResources}/api/course-plan/filter?filterType=class&id=`,
  "GET_COURSE_PLAN_BY_COURSE": `${baseDomainResources}/api/course-plan/filter?filterType=course&id=`,

  // Campus Files
  "CAMPUS_FILE_UPLOAD": `${baseDomainResources}/api/campus-file-system/file/upload`,
  "CAMPUS_FILE_GET_BY_ENTITY": `${baseDomainResources}/api/campus-file-system/file/entity`,
  "CAMPUS_FILE_DELETE": `${baseDomainResources}/api/campus-file-system/file`,
  "CAMPUS_FILE_SYSTEM_UPLOAD": `${baseDomainResources}/api/campus-file-system/file/upload`,
  "CAMPUS_FILE_SYSTEM_FILE": `${baseDomainResources}/api/campus-file-system/file`,
  "CAMPUS_FILE_SYSTEM_ENTITY": `${baseDomainResources}/api/campus-file-system/file/entity`,
  "RESOURCES_COURSE_PLAN": `${baseDomainResources}/api/course-plan`,
  "RESOURCES_EVENTS": `${baseDomainResources}/api/events?`,
  "RESOURCES_QUICK_NOTES": `${baseDomainResources}/api/quick-notes`,
  "RESOURCES_API": `${baseDomainResources}/api`,
  "RESOURCES_ASSESSMENT_EVENT": `${baseDomainResources}/api/assessment/event`,
  "RESOURCES_STUDENT_PERFORMANCE": `${baseDomainResources}/api/student-performance`,

  // Grading System
  "GET_EVENTS": `${baseDomainResources}/api/events`,
  "GET_GRADING_SYSTEM_BY_EVENT": `${baseDomainResources}/api/grade/event`,
  "CREATE_GRADING_SYSTEM": `${baseDomainResources}/api/grade`,
  "UPDATE_GRADING_SYSTEM": `${baseDomainResources}/api/grade`,
  "DELETE_GRADING_SYSTEM": `${baseDomainResources}/api/grade`,
  "ATTENDANCE_BASE": `${baseDomainResources}/api/attendance`,

  // Dynamic Resource Routes
  getClassesByOrgUrl: (orgId) => `${baseDomainResources}/api/classes/org/${orgId}`,
  getUploadClassDocumentUrl: (classId) => `${baseDomainResources}/api/classes/${classId}/documents/upload`,
  getCountByUserType: (orgId) => `${baseDomainResources}/api/dashboard/count-by-userType/${orgId}`,
  getCourseCount: (orgId) => `${baseDomainResources}/api/dashboard/courses/count/${orgId}`,
  getAttendanceSummary: (orgId) => `${baseDomainResources}/api/dashboard/attendance/summary/${orgId}`,
  getAttendanceByClass: (orgId, classId) => `${baseDomainResources}/api/attendance/org/${orgId}/type/Class/${classId}`,
  get_resources_resources_course_plan: (planId) => `${baseDomainResources}/api/course-plan/${planId}`,
  get_resources_resources_dashboard_attendance_summary_attendancedate: (orgId, today) => `${baseDomainResources}/api/dashboard/attendance/summary/${orgId}?attendanceDate=${today}`,
  get_resources_resources_quick_notes_user_pagesize_50: (userId) => `${baseDomainResources}/api/quick-notes/user/${userId}?pageSize=50`,
  get_resources_resources_quick_notes: (editId) => `${baseDomainResources}/api/quick-notes/${editId}`,
  get_resources_resources_classes: (classId) => `${baseDomainResources}/api/classes/${classId}`,
  get_resources_resources_student_performance_user_pagesize_20: (userId) => `${baseDomainResources}/api/student-performance/user/${userId}?pageSize=20`,
  get_resources_resources_classes_org: (orgId) => `${baseDomainResources}/api/classes/org/${orgId}`,
  get_resources_resources_courses: (courseId) => `${baseDomainResources}/api/courses/${courseId}`,
  get_resources_resources_student_performance_class: (classId) => `${baseDomainResources}/api/student-performance/class/${classId}`,
  get_resources_resources_student_performance: (id) => `${baseDomainResources}/api/student-performance/${id}`,
  getAttendanceRecords: (filterType, id) => `${baseDomainResources}/api/attendance/records/${filterType}/${id}`,

  // ==========================================
  // 3. CAMPUS INFRASTRUCTURE SERVICES (Port 8002)
  // ==========================================
  "SEND_EMAIL_NOTIFICATION": `${baseDomainInfrastructure}/api/notifications/email`,
  "SEND_SMS_NOTIFICATION": `${baseDomainInfrastructure}/api/notifications/sms`,
  "INBOX_SEND": `${baseDomainInfrastructure}/api/inbox/send`,
  "INBOX_MAILBOX": `${baseDomainInfrastructure}/api/inbox/mailbox`,
  "INBOX_CONVERSATION": `${baseDomainInfrastructure}/api/inbox/conversations`,
  "INBOX_UNREAD_COUNT": `${baseDomainInfrastructure}/api/inbox/unread-count`,
  "INBOX_BULK_STATUS": `${baseDomainInfrastructure}/api/inbox/conversations/bulk-status`,
  "GET_FEE_STRUCTURE": `${baseDomainInfrastructure}/api/feestructure`,
  "GET_NOTIFICATION_TEMPLATES": `${baseDomainInfrastructure}/api/notifications/templates`,
  "GET_FEE_PAYMENTS_BY_USER": `${baseDomainInfrastructure}/api/feepayment/user`,
  "INITIATE_FEE_PAYMENT": `${baseDomainInfrastructure}/api/feepayment/initiate`,
  "VERIFY_FEE_PAYMENT": `${baseDomainInfrastructure}/api/feepayment/verify`,
  "INFRASTRUCTURE_FEEANALYTICS_SUMMARY": `${baseDomainInfrastructure}/api/feeanalytics/summary`,
  "INFRASTRUCTURE_FEEPAYMENT": `${baseDomainInfrastructure}/api/feepayment`,
  "INFRASTRUCTURE_NOTIFICATIONS_EMAIL": `${baseDomainInfrastructure}/api/notifications/email`,
  "AI_NOTIFICATION_GENERATE": `${baseDomainIdentity}/api/ai-notifications/generate`,

  // WhatsApp APIs
  "WHATSAPP_SEND_TEMPLATE": (template) => `${baseDomainInfrastructure}/api/whatsapp/messages/${template}`,
  "WHATSAPP_TEMPLATES": `${baseDomainInfrastructure}/api/whatsapp/messages/templates`,
  "WHATSAPP_MESSAGE_LOG": `${baseDomainInfrastructure}/api/whatsapp/messages/log`,
  "WHATSAPP_OPT_OUTS": `${baseDomainInfrastructure}/api/whatsapp/opt-outs`,
  "WHATSAPP_STUCK_INTENTS": `${baseDomainInfrastructure}/api/whatsapp/send-intents/stuck`,
  "WHATSAPP_FEE_REMINDER": `${baseDomainInfrastructure}/api/feepayment/whatsapp-reminder`,
  "WHATSAPP_PAYMENT_SCREENSHOTS": `${baseDomainInfrastructure}/api/feepayment/whatsapp-screenshots`,
  "WHATSAPP_SCREENSHOT_ATTACH": `${baseDomainInfrastructure}/api/feepayment/whatsapp-screenshots/attach`,

  // Dynamic Infrastructure Routes
  get_infrastructure_infrastructure_feestructure_2025_2026: (classId) => `${baseDomainInfrastructure}/api/feestructure/class/${classId}?academicYear=2025-2026`,
  get_infrastructure_infrastructure_feepayment_user: (userId) => `${baseDomainInfrastructure}/api/feepayment/user/${userId}`,
  get_infrastructure_infrastructure_feeanalytics_student: (userId) => `${baseDomainInfrastructure}/api/feeanalytics/student/${userId}`,
  get_inbox_conversation_status: (conversationId) => `${baseDomainInfrastructure}/api/inbox/conversations/${conversationId}/status`,

  // Student Fee Profile & Overrides / Concessions APIs
  "STUDENT_FEE_PROFILE": `${baseDomainInfrastructure}/api/student-fee-profile`,
  get_student_fee_profile_student: (studentId) => `${baseDomainInfrastructure}/api/student-fee-profile/student/${studentId}`,
  get_student_fee_profile_class: (classId) => `${baseDomainInfrastructure}/api/student-fee-profile/class/${classId}`,

  // ==========================================
  // 4. EXTERNAL KEYS
  // ==========================================
  "RAZORPAY_KEY_ID": "rzp_test_FgrDHNvm4qeT1t",
  "AI_NOTIFICATION_DRAFT": `${baseDomainResources}/api/ai-conversation/notification-draft`,
  "IDENTITY_HEALTH": `${baseDomainIdentity}/api/health`,
  "RESOURCES_HEALTH": `${baseDomainResources}/api/health`,
  "INFRASTRUCTURE_HEALTH": `${baseDomainInfrastructure}/api/health`,
};

export default configData;
